import {
  AppStorageKeys,
  getJson,
  getString,
  setJson,
  setString,
} from "../../lib/appStorage.js";

/**
 * Soft self-declared segment captured during onboarding. Deliberately limited to
 * `adopter | visitor` — publisher intent is NOT a userType (it routes to the
 * Join Chooser at /quero-anunciar instead, see CONTEXT.md "Particular").
 */
export type OnboardingUserType = "adopter" | "visitor";

/**
 * Lightweight PawMatch preference snapshot collected in onboarding. Mapped onto
 * the richer `PawMatchPreferences` shape when synced to the backend after login.
 */
export interface OnboardingPawMatchPrefs {
  speciesMode: "dogs" | "cats" | "both" | null;
  size: string | null;
  energyLevel: string | null;
}

export async function setOnboardingUserType(
  userType: OnboardingUserType,
): Promise<void> {
  await setString(AppStorageKeys.ONBOARDING_USER_TYPE, userType);
}

export async function getOnboardingUserType(): Promise<OnboardingUserType | null> {
  const value = await getString(AppStorageKeys.ONBOARDING_USER_TYPE);
  return value === "adopter" || value === "visitor" ? value : null;
}

export async function setOnboardingPawMatchPrefs(
  prefs: OnboardingPawMatchPrefs,
): Promise<void> {
  await setJson(AppStorageKeys.ONBOARDING_PAWMATCH_PREFS, prefs);
}

export async function getOnboardingPawMatchPrefs(): Promise<OnboardingPawMatchPrefs | null> {
  return getJson<OnboardingPawMatchPrefs>(
    AppStorageKeys.ONBOARDING_PAWMATCH_PREFS,
  );
}

/** Clears the locally stored onboarding choices once they've been synced. */
export async function clearOnboardingChoices(): Promise<void> {
  await setString(AppStorageKeys.ONBOARDING_USER_TYPE, null);
  await setJson(AppStorageKeys.ONBOARDING_PAWMATCH_PREFS, null);
}
